module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header",
    class: {
      'header_flex': _vm.$slots.selector
    }
  }, [(_vm.$slots.selector) ? [_c('div', {
    staticClass: "header__text"
  }, [_c('h2', {
    staticClass: "header__title"
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.subtitle) ? _c('p', {
    staticClass: "header__sub"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]), _c('div', {
    staticClass: "header__selector"
  }, [_vm._t("selector")], 2)] : [_c('h2', {
    staticClass: "header__title"
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.subtitle) ? _c('p', {
    staticClass: "header__sub"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b0614ee","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/components/top/components/header/Header.vue
// module id = 0ebb1dfdd5032b904807
// module chunks = 0